const messages = {
    firestorePath: 'reservations/{reservationId}/messages',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'messages',
    statePropName: 'data',
    namespaced: true, // automatically added
  
    // this object is your store module (will be added as '/myModule')
    // you can also add state/getters/mutations/actions
    state: {},
    getters: {},
    mutations: {},
    actions: {},
  }
  
  export default messages